import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MediaRecording } from 'src/app/models/media-recording.model';

@Pipe({
  name: 'mediaRecordingServerProcessingLabel',
  standalone: true,
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class MediaRecordingServerProcessingLabelPipe implements PipeTransform {
  transform(recording: MediaRecording | null | undefined): string {
    if (recording === null || recording === undefined) {
      return '';
    }

    return this.getMediaRecordingServerProcessingStatusLabel(recording);
  }

  private getMediaRecordingServerProcessingStatusLabel(recording: MediaRecording): string {
    if (recording.server_processing_status === 'queued') {
      return recording.media_type === 'video'
        ? 'En cola de procesamiento. El servidor fusionará el vídeo y lo subirá a YouTube.'
        : 'En cola de procesamiento en el servidor.';
    }

    if (recording.server_processing_status === 'processing') {
      return recording.media_type === 'video' ? 'Procesando vídeo en el servidor…' : 'Procesando grabación…';
    }

    if (recording.youtube_upload_status === 'uploading') {
      return 'Subiendo a YouTube…';
    }

    if (recording.recording_status === 'uploading') {
      return 'Subiendo fragmentos al servidor…';
    }

    return 'Procesando…';
  }
}
